export class IotControlOpenGateResponseModel {
  status!: number
  description!: string
}
